module.exports = __webpack_public_path__ + "img/events-bottom.b9e4780.png";